import React from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import NewAdminsList from './NewAdminsList'
import { filterRelationshipManagers, filterAccountManagers, filterLendingManagers } from './helpers/adminRoleFilters'
import BlueLoadingButton from '../common/BlueLoadingButton'
import podType from '../common/types/podType'
import administratorType from '../common/types/administratorType'
import ManagePod from './queries/ManagePod'
import PodsQuery from './queries/PodsQuery'

const Container = styled.div`
  padding: 40px;
  flex-basis: 30%;
  background: #f7f7f7;
  max-width: 400px;
  box-shadow: 3px 3px 7px -1px rgba(0,0,0,0.6);
  border-radius: 3px;
`
const NameContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 35px;
`
const NameInput = styled.input`
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  font-family: "Zilla Slab", serif !important;
  font-size: 24px !important;
  width: 100%;
  height: 42px;
  font-weight: 500;
  &:focus {
    border: none !important;
    box-shadow: none !important;
  }
`
const BottomBorder = styled.svg`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  width: 100%;
`
const ButtonsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
const Cancel = styled.div`
  cursor: pointer;
  text-decoration: underline;
  color: #58585c;
  line-height: 20px;
`
const RoleTitle = styled.div`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 17px;
  font-weight: 600;
  line-height: 28px;
  height: 28px;
  margin-bottom: 10px;
`

export class NewPodCard extends React.Component {
  constructor(props) {
    super(props)
    const { pod } = props
    this.state = {
      admins: pod ? pod.admins : [],
      name: pod ? pod.name : ''
    }
  }
  static propTypes = {
    allAdmins: PropTypes.arrayOf(administratorType),
    managePod: PropTypes.func.isRequired,
    onCancel:  PropTypes.func.isRequired,
    pod:       podType
  }
  isValid = () => {
    const { admins, name } = this.state
    const relationshipManagers = filterRelationshipManagers(admins).length
    const accountManagers = filterAccountManagers(admins).length
    return relationshipManagers > 0 && accountManagers > 0 && name.length > 0
  }
  onAdminSelect = ({ oldAdmin = {}, newAdmin }) => {
    let { admins } = this.state
    if (oldAdmin.rid) {
      const adminsCopy = admins.slice()
      const oldIndex = adminsCopy.findIndex(admin => admin.rid === oldAdmin.rid)
      adminsCopy[oldIndex] = newAdmin
      admins = adminsCopy
    } else {
      admins = admins.concat([newAdmin])
    }
    this.setState({ admins })

  }
  onAdminRemove = rid => {
    const { admins } = this.state
    const adminsCopy = admins.slice()
    const index = adminsCopy.findIndex(admin => admin.rid === rid)
    adminsCopy.splice(index, 1)
    this.setState({ admins: adminsCopy })
  }
  onNameChange = e => {
    this.setState({ name: e.target.value })
  }
  onSubmit = async () => {
    const { managePod, pod } = this.props
    const { admins, name } = this.state
    this.setState({ loading: true })
    await managePod({
      variables: {
        podId: pod ? pod.rid : null,
        adminIds: admins.map(admin => admin.rid),
        name
      },
      update: (store, { data: { managePod: { pod } } }) => {
        const queryVars = { query: PodsQuery, variables: { role: 'UW' } }
        const data = store.readQuery(queryVars)
        const oldPodIndex = data.pods.findIndex(oldPod => oldPod.rid === pod.rid)
        if (oldPodIndex > -1) {
          data.pods[oldPodIndex] = pod
        } else {
          data.pods.push(pod)
        }
        store.writeQuery({ ...queryVars, data })
      }
    })
    this.props.onCancel()
  }
  render() {
    const { name, admins, loading } = this.state
    const { allAdmins, onCancel } = this.props
    const allLendingManagers = filterLendingManagers(allAdmins)
    const allRelationshipManagers = filterRelationshipManagers(allAdmins)
    const allAccountManagers = filterAccountManagers(allAdmins)
    const relationshipManagers = filterRelationshipManagers(admins)
    const accountManagers = filterAccountManagers(admins)
    const lendingManagers = filterLendingManagers(admins)
    const autocompleteProps = { onAdminSelect: this.onAdminSelect, onAdminRemove: this.onAdminRemove }
    return (
      <Container>
        <NameContainer>
          <NameInput
            placeholder="Enter a Pod Name..."
            value={name}
            onChange={this.onNameChange}
            type="text"
          />
          <BottomBorder>
            <line
              x1="0%"
              x2="100%"
              y1="99%"
              y2="99%"
              stroke="black"
              strokeDasharray="7"
            />
          </BottomBorder>
        </NameContainer>
        <RoleTitle>Lending Managers</RoleTitle>
        <NewAdminsList selectedAdmins={lendingManagers} allAdmins={allLendingManagers} {...autocompleteProps} />
        <RoleTitle>Account Managers</RoleTitle>
        <NewAdminsList selectedAdmins={accountManagers} allAdmins={allAccountManagers} {...autocompleteProps} />
        <RoleTitle>Relationship Managers</RoleTitle>
        <NewAdminsList selectedAdmins={relationshipManagers} allAdmins={allRelationshipManagers} {...autocompleteProps} />
        <ButtonsContainer>
          <BlueLoadingButton disabled={!this.isValid()} loading={loading} onClick={this.onSubmit}>
            Save
          </BlueLoadingButton>
          <Cancel onClick={onCancel}>
            Cancel
          </Cancel>
        </ButtonsContainer>
      </Container>
    )
  }
}

export default graphql(ManagePod, {
  name: 'managePod'
})(NewPodCard)
